import { render, staticRenderFns } from "./PlayerEval.vue?vue&type=template&id=23ae322c&"
import script from "./PlayerEval.vue?vue&type=script&lang=js&"
export * from "./PlayerEval.vue?vue&type=script&lang=js&"
import style0 from "./PlayerEval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports